import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

export function LegalFooter() {
  const t = useTranslations("auth.common");
  return (
    <p className="text-center text-xs leading-relaxed text-ink-faint">
      {t("termsBefore")}
      <Link href="/terms" className="underline decoration-ink-faint/40 underline-offset-4 hover:text-ink-dim">
        {t("terms")}
      </Link>
      {" "}
      {t("and")}
      {" "}
      <Link href="/privacy" className="underline decoration-ink-faint/40 underline-offset-4 hover:text-ink-dim">
        {t("privacy")}
      </Link>
      {t("termsAfter")}
    </p>
  );
}
